import { render, staticRenderFns } from "./BarChartRiddlesNumber.vue?vue&type=template&id=777556a8&scoped=true&"
import script from "./BarChartRiddlesNumber.vue?vue&type=script&lang=js&"
export * from "./BarChartRiddlesNumber.vue?vue&type=script&lang=js&"
import style0 from "./BarChartRiddlesNumber.vue?vue&type=style&index=0&id=777556a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777556a8",
  null
  
)

export default component.exports